import {
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILURE
} from '../types/taskTypes';
import api from '../../services/api';

// Fetch Tasks
export const fetchTasksRequest = () => ({
  type: FETCH_TASKS_REQUEST
});

export const fetchTasksSuccess = (data) => ({
  type: FETCH_TASKS_SUCCESS,
  payload: data
});

export const fetchTasksFailure = (error) => ({
  type: FETCH_TASKS_FAILURE,
  payload: error
});

export const fetchTasks = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchTasksRequest());
    try {
      const response = await api.get('/songs/admin/songs', { params });
      if (response.data.success) {
        dispatch(fetchTasksSuccess(response.data.data));
      } else {
        dispatch(fetchTasksFailure(response.data.message || 'Failed to fetch tasks'));
      }
    } catch (error) {
      dispatch(fetchTasksFailure(error.response?.data?.message || 'Failed to fetch tasks'));
    }
  };
};

